import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import mask from '@alpinejs/mask'
import axios from 'axios'
import newsletter from './components/newsletter'
import flats_list from './components/flats_list'
import mortage_calculator from './components/mortage_calculator'
import notifications from './components/notifications'

import Cookie from './cookies'

Alpine.plugin(collapse)
Alpine.plugin(persist)
Alpine.plugin(focus)
Alpine.plugin(mask)

Alpine.data('newsletter', newsletter)
Alpine.data('flatsList', flats_list)
Alpine.data('mortageCalculator', mortage_calculator)
Alpine.data('notifications', notifications)


window.Alpine = Alpine
window.axios = axios
window.Cookie = Cookie

document.addEventListener('alpine:init', () => {


    window.setAlpineFilter = function (value, filter, artboard) {
        document.getElementById('filter').dispatchEvent(new CustomEvent('set-filter-value', {
            detail: {
                value: value,
                filter: filter,
                artboard: artboard
            }
        }));
    }

    Alpine.directive('tooltip', (el, {expression}) => {
        tippy(el, {
            theme: 'ceresne',
            content: expression,
        })
    })

    window.showFlat = function (flat) {
        return window.open('/ponuka-bytov/byt/' + flat.toLowerCase(), '_blank');
    }


    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    document.addEventListener('DOMContentLoaded', function () {

        const divElement = document.querySelector('.map-holder');
        const flatTable = document.querySelector('.offer-table');

        if (divElement) {
            const handleScroll = debounce(function () {
                if (divElement.scrollLeft > 0) {
                    divElement.classList.add('scrolled');
                } else {
                    divElement.classList.remove('scrolled');
                }
            }, 200); // Adjust the debounce delay as needed

            divElement.addEventListener('scroll', handleScroll);
        }


        if (flatTable) {
            const handleScroll = debounce(function () {
                const stickyColumns = flatTable.querySelectorAll('.sticky-column');
                if (flatTable.scrollLeft > 0) {
                    stickyColumns.forEach(column => column.classList.add('with-shadow'));
                } else {
                    stickyColumns.forEach(column => column.classList.remove('with-shadow'));
                }
            }, 10); // Adjust the debounce delay as needed

            flatTable.addEventListener('scroll', handleScroll);
        }


    });

    const handleResize = debounce(function () {
        const container = document.querySelector('.map-holder .imp-container');
        if (!container) {
            return;
        }
        const impScaleElement = document.querySelector('.imp-scale');
        const impScaleWidth = impScaleElement.offsetWidth;

        if (container) {
            container.style.width = impScaleWidth + 'px';
        }
    }, 200);

    if (window.innerWidth <= 759) {
        document.addEventListener('scroll', handleResize);
    }

    window.addEventListener('resize', handleResize); // Add resize event listener

    if (typeof ImageMapPro !== 'undefined') {
        ImageMapPro.subscribe((action) => {

            if (action.type === 'mapInit') {
                const host = window.location.origin;
                const uri = host + '/app/themes/ceresne/assets/dist/images/map/';

                const impScaleElement = document.querySelector('.imp-scale');

                const container = document.querySelector('.map-holder .imp-container');

                if (!container) {
                    return;
                }


                const impScaleWidth = impScaleElement.offsetWidth;


                if (window.innerWidth <= 759) {
                    container.style.width = impScaleWidth + 'px';
                }

                if (impScaleElement) {
                    const images = `
            <img src="${uri}UP.png" alt="" class="tw-absolute tw-inset-0 tw-w-full tw-h-full overlay" id="building_S" style="display: none; z-index: 1;"/>
            <img src="${uri}RESIDENCE.png" alt="" class="tw-absolute tw-inset-0 tw-w-full tw-h-full overlay" id="building_OPR" style="display: none; z-index: 1;"/>
            <img src="${uri}PLAZA_V1.png" alt="" class="tw-absolute tw-inset-0 tw-w-full tw-h-full overlay" id="building_TUV" style="display: none; z-index: 1;"/>
        `;
                    impScaleElement.insertAdjacentHTML('beforeend', images);
                }

            }

            const overlayImages = document.querySelectorAll('.overlay');


            if (action.type === 'objectHighlight') {

                const container = document.querySelector('.map-holder .imp-container');

                if (!container) {
                    return;
                }

                overlayImages.forEach(image => {
                    image.style.display = 'none';
                });

                const map_object = action.payload.object;
                const imageElement = document.getElementById(map_object);
                if (imageElement) {
                    fadeIn(imageElement, 'block');
                }
            }

            if (action.type === 'objectUnhighlight') {


                const container = document.querySelector('.map-holder .imp-container');

                if (!container) {
                    return;
                }

                const map_object = action.payload.object;
                const imageElement = document.getElementById(map_object);
                if (imageElement) {
                    fadeOut(imageElement);
                }
            }

        });
    }
})

// ** FADE OUT FUNCTION **
function fadeOut(el) {
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= .1) <= 0) {
            el.style.display = "none";
        } else {
            requestAnimationFrame(fade);
        }
    })();
}

// ** FADE IN FUNCTION **
function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += .1) >= 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
}

Alpine.start()
